import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicGuardService } from '@workflow/dynamic-guard/dynamic-guard.decorator';
import { AdminPortalFeaturesService } from '../service/user/admin-portal-features.service';

@DynamicGuardService('ApplicationExperienceGuard')
@Injectable({
  providedIn: 'root'
})
export class ApplicationExperienceGuard {
  constructor(private adminportalService: AdminPortalFeaturesService, private router: Router) {}
  public canActivate(): boolean {
    if (
      this.adminportalService.config &&
      this.adminportalService.config.olaFeatures &&
      !this.adminportalService.config.olaFeatures.canShowApplicationExperience
    ) {
      this.router.navigate(['/oops']);
      return false;
    }

    return true;
  }
}
